
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...vertical]",
      function () {
        return require("private-next-pages/[...vertical].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...vertical]"])
      });
    }
  